jQuery(($) => {
    var iframe = document.getElementById('sketchfab-iframe'),
        uid = $(iframe).attr('model-id');

    if ( iframe == null ) return;

    // By default, the latest version of the viewer API will be used.
    var client = new Sketchfab(iframe);

    // Alternatively, you can request a specific version.
    // var client = new Sketchfab( '1.12.1', iframe );

    client.init(uid, {
        camera: 0,
        blending: 1,
        autospin: 0,
        annotation_cycle: 4,
        transparent: 0,
        autostart: 1,
        transparent: 1,
        ui_animations: 0,
        ui_infos: 0,
        ui_stop: 0,
        ui_inspector: 0,
        ui_watermark_link: 0,
        ui_watermark: 0,
        ui_settings: 0,
        ui_fullscreen: 0,
        scrollwheel: 0,
        ui_theme: 'dark',
        ui_fadeout: 0,
        success: function onSuccess(api) {
            api.start();
            api.addEventListener('viewerready', function () {

                // API is ready to use
                // Insert your code here
                $('.a-sketchfab-iframe').addClass('ready');
            });
        },
        error: function onError() {
        }
    });
});